import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, Store, CreditCard, Package, ScrollText, LogOut, Printer, Menu, X, Settings } from "lucide-react";

const items = [
  { to: "/admin", icon: LayoutDashboard, label: "Dashboard", end: true, testid: "nav-admin-dashboard" },
  { to: "/admin/stores", icon: Store, label: "Stores", testid: "nav-admin-stores" },
  { to: "/admin/plans", icon: Package, label: "Plans", testid: "nav-admin-plans" },
  { to: "/admin/subscriptions", icon: CreditCard, label: "Subscriptions", testid: "nav-admin-subs" },
  { to: "/admin/platform-settings", icon: Settings, label: "Platform Settings", testid: "nav-admin-platform" },
  { to: "/admin/audit", icon: ScrollText, label: "Audit Logs", testid: "nav-admin-audit" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen dashboard-bg lg:flex">
      {/* Mobile top bar */}
      <div className="lg:hidden sticky top-0 z-30 bg-white/95 backdrop-blur border-b border-slate-200 h-14 px-4 flex items-center justify-between">
        <button data-testid="admin-menu-open" onClick={() => setOpen(true)} className="p-2 -ml-2 rounded-lg hover:bg-slate-100"><Menu className="w-5 h-5" /></button>
        <div className="flex items-center gap-2">
          <img src="/logo.png" alt="Print Plus" className="w-8 h-8 object-contain" />
          <div className="font-display font-bold text-sm">Print Plus</div>
        </div>
        <div className="w-9" />
      </div>

      {open && <div onClick={() => setOpen(false)} className="lg:hidden fixed inset-0 z-40 bg-slate-900/50 backdrop-blur-sm animate-in fade-in" />}

      <aside className={`fixed lg:sticky top-0 left-0 z-50 h-screen w-72 lg:w-64 border-r border-slate-200 bg-white flex flex-col shadow-xl lg:shadow-none transition-transform ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}>
        <div className="p-5 border-b border-slate-200 flex items-center gap-2">
          <img src="/logo.png" alt="Print Plus" className="w-10 h-10 object-contain" />
          <div className="flex-1 min-w-0">
            <div className="font-display font-bold leading-none">Print Plus</div>
            <div className="text-[9px] uppercase tracking-widest text-slate-400 font-semibold mt-0.5">by AI Upaya</div>
            <div className="text-[10px] uppercase tracking-widest text-orange-500 font-semibold mt-1">Super Admin</div>
          </div>
          <button data-testid="admin-menu-close" onClick={() => setOpen(false)} className="lg:hidden p-2 -mr-2 rounded-lg hover:bg-slate-100"><X className="w-4 h-4" /></button>
        </div>
        <nav className="p-3 space-y-1 flex-1 overflow-y-auto">
          {items.map((it) => (
            <NavLink key={it.to} to={it.to} end={it.end} data-testid={it.testid} onClick={() => setOpen(false)}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition ${isActive ? "bg-orange-50 text-orange-700" : "text-slate-600 hover:bg-slate-50 active:bg-slate-100"}`}>
              <it.icon className="w-4 h-4" />{it.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-slate-200">
          <div className="px-3 py-2 text-xs text-slate-500 truncate">{user?.email}</div>
          <Button variant="ghost" size="sm" className="w-full justify-start" onClick={async () => { await logout(); nav("/login"); }} data-testid="admin-logout">
            <LogOut className="w-4 h-4 mr-2" />Sign out
          </Button>
        </div>
      </aside>

      <main className="flex-1 min-w-0 overflow-x-hidden"><Outlet /></main>
    </div>
  );
}
